import axios from 'axios';

const API_URL = 'https://serveraerostacxxz.myflixcode.com/api';

// Create a separate axios instance for registration
const registerApi = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Create the main API instance with auth interceptor
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if it exists
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (userData) => registerApi.post('/users/register/student', userData),
};

// Exam API
export const examAPI = {
  createExam: (examData) => api.post('/exams', examData),
  getExams: () => api.get('/exams'),
  getExam: (examId) => api.get(`/exams/${examId}`),
  assignExam: (examId, studentIds) => api.post(`/exams/${examId}/assign`, { studentIds }),
  getAssignedExams: () => api.get('/exams/assigned'),
  startExam: (examId) => api.post(`/exams/${examId}/start`),
  submitExam: (data) => api.post('/exams/submit', data),
  getResults: () => api.get('/exams/results'),
  getExamResults: (examId) => api.get(`/exams/${examId}/results`),
  getStudentResults: (studentId) => api.get(`/exams/student/${studentId}/results`),
  deleteExam: (examId) => api.delete(`/exams/${examId}`),
  getAllResults: () => api.get('/exams/results'),
  getStudentExamDetails: (attemptId) => api.get(`/exams/attempt/${attemptId}/details`),
  downloadExamPDF: (examId) => {
    return axios.get(`${API_URL}/exams/${examId}/pdf`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
  },
};

// User API
export const userAPI = {
  getStudents: () => api.get('/users/students'),
  getExamHistory: () => api.get('/users/exam-history'),
  getExamDetails: (attemptId) => api.get(`/users/exam-details/${attemptId}`),
  getStudentExamDetails: (attemptId) => api.get(`/users/student-exam/${attemptId}`),
  getStudentHistory: (studentId) => api.get(`/users/student-history/${studentId}`),
  getAdmins: () => api.get('/users/admins'),
  createAdmin: (adminData) => api.post('/users/admins', adminData),
  updateAdmin: (adminId, adminData) => api.put(`/users/admins/${adminId}`, adminData),
  deleteAdmin: (adminId) => api.delete(`/users/admins/${adminId}`),
  getStudentProfile: () => api.get('/users/student/profile'),
  updateStudentProfile: (profileData) => api.put('/users/student/profile', profileData),
};

export default api; 